import currencyFormatter from "../../../../utils/currencyFormatter";
import { abs, sign, divide, multiply } from "../../../../utils/mathUtils";

export const format = value => currencyFormatter.format(value || 0);
export const friendlyFormat = value => {
  if (abs(value) > 999999) {
    return `$${multiply(sign(value), divide(abs(value), 1000000)).toFixed(1)}M`;
  }
  return abs(value) > 999
    ? `$${multiply(sign(value), divide(abs(value), 1000)).toFixed(1)}k`
    : `$${multiply(sign(value), abs(value))}`;
};
